/* global session, $t store config */


export default
{
  props:
  {
    username:
    {
      type: String
    },
    password:
    {
      type: String
    },
    resetFn: Function
  },
  beforeRouteEnter (to, from, next) {
    if (session.isOnline()) {
      let role = session.getSession().user.role;
      let homePage = (role === 'admin' ? '/admin/dashboard' : (['agency', 'caseworker'].indexOf(role) > -1 ? '/agency/dashboard' : (role === 'parent' ? '/dashboard' : '/dashboard')));
      next({ path: homePage });
    } else {
      if (to.query.requestFrom && to.query.requestFrom === 'invalid' && (to.name !== 'Login' || config.host.indexOf('localhost') === -1)) {
        session.logout();
      } else {
        next();
      }
    }
  },
  data: () => ({
    config,
    loading: false,
    error: '',
    longError: '',
    form:
    {
      username:
      {
        disabled: false,
        placeholder: 'Type the username',
        value: ''
      },
      password:
      {
        disabled: false,
        placeholder: 'Type the password',
        value: ''
      },
    },
    model:
    {
      username: '',
      password: ''
    },
    showPassword: false
  }),
  computed: {
    swagger () {
      return this.store.state.swagger;
    },
    signupLink () {
      return config.newUI.host + '/register/all';
    }
  },
  created () {
    window.getApp.$emit('BGProgress', true);
  },
  beforeDestroy () {
    window.getApp.$emit('BGProgress', false);
  },
  methods: {
    login () {
      if (this.$refs.loginForm.validate()) {
        this.error = '';
        this.longError = '';
        let scope = this;
        let username = scope.$refs.username.value.trim();
        let password = scope.$refs.password.value.trim();
        let sigInBtn = scope.$refs.sigInBtn;
        scope.loading = true;
        // sigInBtn.loading = true;
        
        if (scope.rememberMe)
        {
          localStorage.setItem('username', username);
        }
        else
        {
          localStorage.setItem('username', '');
        }
  
        scope.form.username.disabled = true;
        scope.form.password.disabled = true;
        
        session.login({
          username,
          password,
          success: (sessionData) =>
          {

            let user = sessionData.user;
            // Logout if foster family or child management agency logged in
            let isChildAgency = user.role === 'agency' ? user.human && user.human.agency && user.human.agency.feature_settings && user.human.agency.feature_settings[0] === 'ChildManagement' : false;
            if (user.role === 'foster' || (user.role === 'agency' && isChildAgency)) {
              scope.loading = false;
              this.error = 'Unauthorized Access';
              this.longError = 'You are not authorized to access this portal.';
              scope.form.username.disabled = false;
              scope.form.password.disabled = false;
              session.logout(false);
              return;
            }
            
            scope.store.commit('setSession', sessionData);
            // 
            // scope.loading = false;
            // sigInBtn.false
            let homePage = (sessionData.user.role === 'admin' ? '/admin/dashboard' : (['agency', 'caseworker'].indexOf(sessionData.user.role) > -1 ? '/agency/dashboard' : (sessionData.user.role === 'parent' ? '/dashboard' : '/dashboard')));
            scope.$router.push(homePage);
          },
          onExpires: () =>
          {
            alert('Session expired');
          },
          error: (err) =>
          {
            if (err.indexOf('is not correct') > -1 || err.indexOf('is not registered') > -1) {
              this.longError = 'The username or password you entered is incorrect. Check to make sure your Caps Lock is off, and that you are using the correct username and password.';
              this.error = 'Invalid credentials';
            } else {
              this.error = err;
            }
            scope.form.username.disabled = false;
            scope.form.password.disabled = false;
            scope.loading = false;
          }
        });
      } else {
        this.error = 'Please enter the username and password';
        this.longError = 'Please make sure you entered your username and password before trying to login';
      }
    }
  }
};
 


// WEBPACK FOOTER //
// ./src/pages/Login.vm.js